import { render, staticRenderFns } from "./MediaUrl.vue?vue&type=template&id=16521c1a"
import script from "./MediaUrl.vue?vue&type=script&lang=js"
export * from "./MediaUrl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports